<div class="container mx-auto w-full sm:px-4">
  @if (oshAnalyses()?.length) {
    <div class="mt-6 flex w-full flex-col gap-4">
      @for (oshAnalysis of oshAnalyses(); track oshAnalysis?.id) {
        <div
          animate.enter="fade-in"
          class="flex w-full items-start gap-2"
        >
          <proffeo-osh-tree-item
            (oshAnalysisEdited)="editOshAnalysis($event)"
            (oshAnalysisDeleted)="deleteOshAnalysis($event)"
            [oshAnalysis]="oshAnalysis"
            class="flex-grow"
          ></proffeo-osh-tree-item>
        </div>
      }
    </div>
  } @else {
    <div
      class="flex w-full items-center justify-center p-6 bg-proffeo-surface rounded-xl border border-proffeo-overlay-subtle shadow-sm"
    >
      <p class="text-proffeo-muted">
        {{ 'placeholders.no-results-found' | translate }}
      </p>
    </div>
  }
</div>
